module.exports = __webpack_public_path__ + "assets/images/container_phase3.2c9d2b0a5251816058a6da467793593e.svg";